import React, { useContext } from "react";
import User from "../../User";
import { AppContext } from "../../../context";
import Settings from "../Settings";
import { createStyles } from "@mantine/emotion";

const useStyles = createStyles((theme) => ({
  header: {
    // borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: "1rem",
    "@media print": {
      display: "none",
    },
  },
  inner: {
    backgroundColor: "var(--header-background)",
    maxWidth: "var(--header-width)",
    margin: "0 auto",
    color: "var(--header-color)",
    height: "var(--header-height)",
    display: "grid",
    alignItems: "center",
    gridTemplateColumns: "1fr auto",
    gridGap: "16px",
    padding: "0 16px",
    "@media(max-width: 768px)": {
      height: "var(--header-height-xs)",
    },
  },
  logoContainer: {
    height: "100%",
    display: "flex",
    alignItems: "center",
  },
  logoLink: {
    lineHeight: 1,
  },
  logoImg: {
    height: "var(--logo-height)",
    width: "var(--logo-width)",
    "@media(max-width: 667px)": {
      height: "var(--logo-height-xs)",
      width: "var(--logo-width-xs)",
    },
  },
  actionWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
}));

const Header = ({ shopUrl, hideUser, language }) => {
  const {
    state: { theme, config },
  } = useContext(AppContext);
  const { classes } = useStyles();
  const getLogoSrc = () => {
    if (theme !== "light") return config.logo_dark;
    return `${config.baseUrl}${config.logo}`;
  };
  return (
    <header className={`${classes.header} header__container`}>
      <a href="#main-page-content" id="main-content-link">
        {language?.SkipToMainContent}
      </a>
      <div className={`${classes.inner} header__innner-container`}>
        <div className={`${classes.logoContainer} header__logo-container`}>
          <a
            href={config.logoUrl || shopUrl}
            className={`${classes.logoLink} header__logo-link`}
            aria-label={language?.Back}
          >
            <img
              src={getLogoSrc()}
              className={`${classes.logoImg} header__logo-img`}
              alt="logo"
            />
          </a>
        </div>
        <div className={classes.actionWrapper}>
          <Settings />
          {!config?.discreetLoginButton && !hideUser && <User />}
        </div>
      </div>
    </header>
  );
};

export default Header;
